import React from 'react';
import _ from 'lodash';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getColor } from 'common/constants/_colors';

const AreaChartV2 = props => {
  const {
    chartOptionsProp,
    chartType = 'area',
    chartColor = 'melrose'
  } = props;
  const chartOptions = {
    chart: {
      type: chartType,
      style: {
        fontFamily: 'Outfit'
      }
    },
    title: {
      text: ''
    },
    xAxis: {
      gridLineWidth: 1
    },
    yAxis: {
      gridLineWidth: 1
    },
    plotOptions: {
      [chartType]: {
        pointPlacement: 'on',
        color: getColor(chartColor),
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, getColor(chartColor, 0.4)],
            [1, getColor(chartColor, 0.001)]
          ]
        },
        marker: {
          radius: 3,
          fillColor: '#ffffff',
          lineColor: getColor(chartColor),
          lineWidth: 1
        },
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 2
          }
        }
      }
    },
    credits: {
      enabled: false
    },

    series: []
  };

  const options = _.merge(chartOptions, chartOptionsProp);

  return (
    <HighchartsReact
      containerProps={{ style: { height: '100%', width: '100%' } }}
      highcharts={Highcharts}
      options={options}
    />
  );
};

export default AreaChartV2;
